<template>
  <div class="lecturer-list clearfix">
    <div
      class="lecturer-item-wrapper"
      v-for="(item, index) in list"
      :key="index"
      @click="listevent(item)"
    >
      <div class="lecturer-item">
        <div class="lecturer-logo">
          <img :src="item.C_LOGO" v-if="item.C_LOGO" />
        </div>
        <div class="lecturer-content">
          <div class="text txt-one-line">
            <b>嘉宾姓名：</b>{{ item.C_TITLE }}
          </div>
          <div class="text txt-one-line">
            <b>公司：</b>{{ item.C_ABSTRACT }}
          </div>
          <div class="text">
            <div class="postion">
              <div class="p-title txt-one-line"><b>职位：</b>{{ item.N_UserDef1 }}</div>
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "lecturerList",
  props: {
    list: {
      type: Array,
      default: [],
    },
  },
  methods: {
    listevent(item) {
      this.$emit("listevent", item);
    },
  },
};
</script>
<style lang="scss" scope>
.lecturer-list {
  padding: 5px;
  width: 100%;
  .lecturer-item-wrapper {
    width: calc(100% / 2);
    // border: 1px solid #000;
    overflow: hidden;
    display: flex;
    float: left;
    box-sizing: border-box;
    padding: 5px;
    .lecturer-item {
      background: #fff;
      border-radius: 5px 5px 3px 3px;
      width: 100%;
      .lecturer-logo {
        display: flex;
        border-radius: 5px 5px 0px 0px;
        img {
          border-radius: 5px 5px 0px 0px;
          height: 150px;
          width: 100%;
          object-fit: cover;
        }
      }
      .lecturer-content {
        font-size: 13px;
        padding: 15px;
        line-height: 22px;
        .text {
          .postion {
            display: flex;
            justify-content: space-between;
            .p-title {
              white-space: nowrap;
              flex: 1;
            }
            .van-icon {
              color: $theme-xtext-color;
              line-height: 22px;
              // float: right;
            }
          }
        }
      }
    }
  }
}
</style>